import { DependencyList, EffectCallback, useEffect } from "react";
import useIsInitialRender from "./useIsInititalRender";

const useUpdateEffect = (callback: EffectCallback, deps?: DependencyList) => {
  const isInitialRender = useIsInitialRender();

  useEffect(() => {
    if (!isInitialRender) {
      callback();
    }
  }, [...(deps ?? []), isInitialRender]);
};

export default useUpdateEffect;
